import { Component, OnInit, Input } from '@angular/core';
import { OmsServiceService } from '../../services/oms-service.service';
import { ConstantsService } from '../../services/constants.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-verity-otp',
  templateUrl: './verity-otp.component.html',
  styleUrls: ['./verity-otp.component.scss']
})
export class VerityOtpComponent implements OnInit {
   @Input() orderObj;
   @Input() isRendOtp ;
   @Input() isSendOtp;

   isOtpSend : boolean=false;
   isOtpValidated : boolean=false;

   listOfReasons: string[];

  isHideSkipOtp: Boolean = true;
  isSkipOtp: Boolean = false;
  
   msg:string ="";
   isSuccessMsg :Boolean =false;
  isFailureMsg :Boolean =false;
  isVerifyOtpDisable:Boolean =false;
  constructor(
    private omsServiceService: OmsServiceService,
    private constantsService: ConstantsService,
    public modal: NgbActiveModal,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService

  ) { }

  ngOnInit(): void {
    this.listOfReasons = [];
   
    //console.log("changes reflected");
    //console.log(this.orderObj);

    if(this.isSendOtp)
    this.sendOtpRequestInfo(this.orderObj.order.patientinfo.contact,this.orderObj.order.patientinfo.email);
    if(this.orderObj.order.business.clientCode != "" && this.orderObj.order.business.clientCode != undefined && this.orderObj.order.business.clientCode =="DRL")
    this.isHideSkipOtp =false;
    if(this.orderObj.order.patientinfo.corporatetype == 'chopd' || this.orderObj.order.patientinfo.corporatetype == 'SVAAS')
    this.isHideSkipOtp =false;
  }


  sendOtpRequestInfo(contactNumber: string, email: string) {

    if(this.orderObj.order.business.clientCode != "" && this.orderObj.order.business.clientCode != undefined && this.orderObj.order.business.clientCode =="DRL")
    {
      this.toastr.error("Re Send Otp is Not avilable For External");
    }else if(this.orderObj.order.patientinfo.corporatetype == 'chopd' || this.orderObj.order.patientinfo.corporatetype == 'SVAAS')
    {
      this.toastr.error("Re Send Otp is Not avilable For External");
    }else {
      this.isOtpSend =false;
      // this.contactNumber = this.orderDetailsRes[0].order.patientinfo.contact;
       //    this.emailAddress = this.orderDetailsRes[0].order.patientinfo.email;
       let orderRequest = {};
       orderRequest["method"] = "api/otp/generate";
       orderRequest["type"] = "post";
       orderRequest["mobile"] = contactNumber;
      // orderRequest["mobile"] = 9618979187;
       orderRequest["component_id"] = "9";
       orderRequest["email"] = email;
       orderRequest["keyValue"] = "MHO00213";
       orderRequest["keyType"] = "ISP";
       orderRequest["sourceType"] = "Mobile-APP";
       orderRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
       this.omsServiceService.sendOtp(orderRequest).subscribe(
         (res) => {
   
          
           if (res["status"] == 1) {
            //console.log(res);
           // alert(res["message"]);
           this.isOtpSend =true;
           }
         }
       )
    }
    
  }
  // sendOtp() {
  //   this.sendOtpRequestInfo(this.contactNumber, this.emailAddress);
  //   //console.log(this.contactNumber, this.emailAddress);
  // }

  verifyOtpRequestInfo(obj) {
    let otp = (<HTMLInputElement>document.getElementById('verifyOtp')).value;
    if(otp != "" && otp !=undefined && otp !=null)
    {
      if(obj.order.business.clientCode != "" && obj.order.business.clientCode != undefined && obj.order.business.clientCode =="DRL")
      {
       this.verifyOtpByExternal(obj);
      }else if(this.orderObj.order.patientinfo.corporatetype == 'chopd' || this.orderObj.order.patientinfo.corporatetype == 'SVAAS'){
          this.verifyOtpByExternal(obj);
      }else{
          this.verifyOtpByInternal(obj);
        // this.verifyOtpByExternal(obj);
 
      }

    }else{

      // alert("please enter OTP");
      this.toastr.error("please enter OTP");
    }
    
    
  }


  confirmOrder(obj) {

    let orderConfirmationRequest = {};

     if (document.getElementById('reason') != undefined) {
       let reason = (<HTMLInputElement>document.getElementById('reason')).value;
       orderConfirmationRequest["reason"] = reason;
     }
   // orderConfirmationRequest["method"] = "OMS/api/operation.php/v1/change/order/status";
    //orderConfirmationRequest["type"] = "POST";
    orderConfirmationRequest["order_id"] = [obj.order.patientinfo.order_id];
    orderConfirmationRequest["actionById"] = window.localStorage.getItem('actionById');;
    orderConfirmationRequest["actionByName"] = window.localStorage.getItem('actionByName');;
    orderConfirmationRequest["source"] = "1";
    orderConfirmationRequest["type"] = "post";
    orderConfirmationRequest["action"] = "OMS/api/operation.php/v1/order/change/status";
   // orderConfirmationRequest["comment"] = "Order confirmation";
    //orderConfirmationRequest["reason"] = "";

    //orderConfirmationRequest["role_id"] = this.constantsService.ROLE_ID;
    orderConfirmationRequest["status"] = 301;
    orderConfirmationRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    this.omsServiceService.orderConfirmation(orderConfirmationRequest).subscribe(
      (res) => {
        //console.log(res);
        //this.confirmOrderResponse = res.message;
        //this.isConfirmedOrder = true;
        //this.modal.close();
        if (res["status"] == 1) {
          // alert("Otp validated successfully");
          //this.isOtpValidated =true;
          //this.isOtpSend  =false;
          // alert(res["message"]);
           this.msg = res["message"];
         //  this.confirmOrder(obj);
         }else{
           
          // alert(res["message"]);
          this.msg = res["message"];
         }

      });

  }

  verifyOtpByExternal(obj) {
   
    let otp = (<HTMLInputElement>document.getElementById('verifyOtp')).value;
    let otpVerifyRequest = {};

   // orderConfirmationRequest["method"] = "OMS/api/operation.php/v1/change/order/status";
    //orderConfirmationRequest["type"] = "POST";
    otpVerifyRequest["orderId"] = obj.order.patientinfo.order_id;
    otpVerifyRequest["otp"] = otp;
    
    this.omsServiceService.externalOtpVerify(otpVerifyRequest).subscribe(
      (res) => {
        //console.log(res);
        //this.confirmOrderResponse = res.message;
        //this.isConfirmedOrder = true;
        if (res["statusCode"] == 200 || res["status_code"] == 200) {
          // alert("Otp validated successfully");
          this.isOtpValidated =true;
          this.isOtpSend  =false;
          this.isVerifyOtpDisable =true;
           //alert(res["dataObject"].message);
          // this.msg = res["status"];
         // alert(res["status"]);
        //  alert("OTP validated successfully");
        this.toastr.success("OTP validated successfully");
           this.confirmOrder(obj);
         }else{
          //this.msg = res["status"];
          // alert("Unable to validate OTP");
          this.toastr.error("Unable to validate OTP");
           //alert(res["dataObject"].message);
         }
      });

  }

verifyOtpByInternal(obj) {
 
   this.SpinnerService.show();
  let otp = (<HTMLInputElement>document.getElementById('verifyOtp')).value;

  let verifyOtpInfoRequest = {};
  verifyOtpInfoRequest["method"] = this.constantsService.OTP_VERIFY_METHOD;
  verifyOtpInfoRequest["type"] = this.constantsService.METHOD_TYPE;

  //verifyOtpInfoRequest["mobile"] = 9618979187;
  verifyOtpInfoRequest["mobile"] = obj.order.patientinfo.contact;
  verifyOtpInfoRequest["email"] = obj.order.patientinfo.email;
  verifyOtpInfoRequest["keyValue"] = "MHO00213";
  verifyOtpInfoRequest["keyType"] = "ISP";
  verifyOtpInfoRequest["sourceType"] = "Mobile-APP";
  verifyOtpInfoRequest["otp"] = otp;


  this.omsServiceService.sendOtp(verifyOtpInfoRequest).subscribe(
    (res) => {

      //this.otpResponse = res["status"];
     //console.log(res);
      if (res["status"] == 1) {
       // alert("Otp validated successfully");
       this.isVerifyOtpDisable =true;
       this.isOtpValidated =true;
       this.isOtpSend  =false;
       // alert(res["message"]);
        this.msg = res["message"];
        this.isSuccessMsg =true;
        this.confirmOrder(obj);
      }else{
        
       // alert(res["message"]);
       this.msg = res["message"];
       this.isFailureMsg =true;
      }
      this.SpinnerService.hide();
    }
  )

  }

  skipOtp() {

    //console.log("skip");
    this.isSkipOtp = true;

    this.listOfReasons = ["Customer is not received OTP", "OTP verification is not required"];
  }

  modelClose()
  {

    this.modal.close();
    
  }
}
